import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
const CardPrice = (props) => {
    const { id, surtitle, title, titleComplement, component = "h3", dynamicList = [], barColor, } = props;
    return (_jsxs(Box, { sx: {
            width: { xs: "100%", md: "580px" },
            flexShrink: 0,
            backgroundColor: "background.paper",
            position: "relative",
            boxSizing: "border-box",
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "6px",
                backgroundColor: barColor || "#0CFFC6",
                zIndex: 2,
            },
        }, children: [(surtitle || title) && (_jsxs(Stack, { spacing: { xs: 0.5, md: 1 }, sx: { p: { xs: "20px", md: "28px 32px" } }, children: [surtitle && (_jsx(Typography, { variant: "body2", sx: { color: "text.secondary" }, children: surtitle })), title && (_jsxs(Typography, { variant: "h1", component: component || "h3", sx: {
                            color: "text.primary",
                            fontSize: { xs: 24, md: 36 },
                        }, children: [title, titleComplement && (_jsx(Typography, { variant: "body1", component: "span", sx: {
                                    color: "text.secondary",
                                    fontWeight: 500,
                                    marginLeft: { xs: "8px", md: "12px" },
                                }, children: titleComplement }))] }))] })), dynamicList.map((row, index) => (_jsxs(React.Fragment, { children: [_jsx(Divider, { sx: { borderColor: "border.default" } }), _jsxs(Stack, { direction: "row", spacing: { xs: 3, md: 8 }, sx: {
                            p: { xs: "16px", md: "16px 24px" },
                            alignItems: "center",
                            justifyContent: "space-between",
                        }, children: [_jsx(Typography, { variant: "body2", sx: {
                                    color: "text.secondary",
                                    maxWidth: { xs: 110, md: "none" },
                                    whiteSpace: { xs: "normal", md: "nowrap" },
                                }, children: row.label }), _jsxs(Typography, { variant: "body1", sx: { color: "text.secondary", textAlign: "right" }, children: [row.amount && (_jsx(Box, { component: "span", sx: { color: "text.primary", fontWeight: 600 }, children: row.amount })), row.amount && row.complement && " · ", _jsx(Typography, { component: "span", sx: {
                                            color: "text.primary",
                                            textAlign: "right",
                                            fontSize: "12px !important",
                                            lineHeight: "130%",
                                        }, children: row.complement })] })] })] }, (row.label || "") + index)))] }, id));
};
export default CardPrice;
